// gatsby-browser.js
import "./src/global.css"